"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewer = void 0;
require("core-js/modules/es.symbol.description.js");
var _paulCorePackage = require("paul-core-package");
var types = _interopRequireWildcard(require("../types/viewer"));
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  viewer: {
    error: [],
    debugModeStatus: false,
    theme: _paulCorePackage.constants.themeKey.light,
    activeCameraPerspective: _constants.CameraPerspective.ThreeD,
    filtration: {
      chilledWater: false,
      hotWater: false,
      circulation: false,
      heatingFlow: false,
      heatingReturn: false
    }
  }
};
const viewer = exports.viewer = function viewer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.viewer;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case types.UPDATE_FILTRATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        filtration: _objectSpread(_objectSpread({}, state.filtration), {}, {
          [payload.name]: payload.value
        })
      });
    case types.SET_PACKAGE_THEME:
      return _objectSpread(_objectSpread({}, state), {}, {
        theme: payload
      });
    case types.SET_DEBUG_MODE_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        debugModeStatus: payload
      });
    case types.ACTIVE_CAMERA_PERSPECTIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeCameraPerspective: payload
      });
    default:
      return state;
  }
};